import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Star, Zap } from 'lucide-react';

const Badge = ({
  children,
  variant = 'default',
  size = 'medium',
  className = '',
  showIcon = false,
  ...props
}) => {
  const variants = {
    default: 'bg-pragyavan-cream text-pragyavan-brown border border-pragyavan-gold/40',
    popular: 'bg-gradient-to-r from-amber-400 to-orange-400 text-white shadow-lg shadow-amber-400/25',
    premium: 'bg-gradient-to-r from-pragyavan-brown to-pragyavan-earth text-pragyavan-gold shadow-lg shadow-pragyavan-brown/20',
    success: 'bg-gradient-to-r from-sage-green to-green-500 text-white shadow-lg shadow-sage-green/25',
    warning: 'bg-gradient-to-r from-orange-400 to-amber-500 text-white shadow-lg shadow-orange-400/25',
    error: 'bg-gradient-to-r from-red-500 to-rose-500 text-white shadow-lg shadow-red-500/25',
    info: 'bg-gradient-to-r from-blue-400 to-indigo-500 text-white shadow-lg shadow-blue-400/25',
    new: 'bg-gradient-to-r from-pragyavan-gold to-accent-gold text-pragyavan-brown shadow-lg shadow-pragyavan-gold/30'
  };

  const iconMap = {
    popular: Star,
    premium: Sparkles,
    new: Zap
  };

  const sizes = {
    small: 'px-2.5 py-1 text-[0.65rem] tracking-wide',
    medium: 'px-3.5 py-1.5 text-xs tracking-wide',
    large: 'px-4 py-2 text-sm tracking-wide'
  };

  const IconComponent = iconMap[variant];

  const badgeClasses = `
    inline-flex items-center justify-center gap-1
    font-semibold rounded-full uppercase
    transition-all duration-300
    ${variants[variant]}
    ${sizes[size]}
    ${className}
  `.trim();

  return (
    <motion.span
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
      className={badgeClasses}
      {...props}
    >
      {showIcon && IconComponent && (
        <IconComponent className="w-3 h-3" />
      )}
      {children}
    </motion.span>
  );
};

export default Badge;